import type {
  BookingSeriesDatePickerDay,
  BookingSeriesOptionsResponse,
  BookingSeriesSlot,
} from './types';

export function getDatePickerDays(
  options: BookingSeriesOptionsResponse | undefined,
  selectedDate: string
): BookingSeriesDatePickerDay[] {
  if (!options) {
    return [];
  }
  return options.days.map((day) => ({
    date: day.date,
    enabled: day.enabled,
    selected: day.date === selectedDate,
    slotCount: day.slots.length,
  }));
}

export function getSlotsForDate(
  options: BookingSeriesOptionsResponse | undefined,
  selectedDate: string
): BookingSeriesSlot[] {
  if (!options || !selectedDate) {
    return [];
  }
  return options.days.find((day) => day.date === selectedDate)?.slots ?? [];
}

export function canShowMoreWeeks(weeks: number): boolean {
  return weeks < 3;
}

export function nextVisibleWeeks(weeks: number): number {
  return Math.min(3, weeks + 1);
}

export function canScheduleSeries(selectedDate: string, selectedStart: string): boolean {
  return selectedDate.trim() !== '' && selectedStart.trim() !== '';
}

export function todayDateString(now: Date = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${now.getFullYear()}-${month}-${day}`;
}
